<script>
    import AppHead from "./AppHead.svelte";
    import SeeDetails from "./SeeDetails.svelte";
    import Gallery from "../components/Gallery.svelte";
    import AppStore from "./LinkToAppStore.svelte";
    import { tatatuItems, soundlyItems } from "./projects-data";
    export let hidefooter = false;
</script>

{#if !hidefooter}
    <div style="height:40px;" />
{/if}

<AppHead
    name="Tatatu"
    icon="images/app_icon_tatatu.png"
    detail="Generally it is an Instagram clone with some extra features" />
<Gallery items={tatatuItems} />
<SeeDetails appStoreLink="https://apps.apple.com/us/app/tatatu/id1385398820" />

<AppHead
    name="Soundly"
    icon="images/app_icon_soundly.png"
    detail="Complex parts: real-time speech recognition, subscriptions, 60 fps gameplay with Sprite Kit " />
<Gallery items={soundlyItems} />
<SeeDetails
    appStoreLink="https://apps.apple.com/us/app/soundly-reduce-snoring/id1138100356" />

<AppHead
    name="Room planner"
    icon="images/app_icon_ihouse.png"
    detail="Complex parts: core graphics, sprite kit, math & geometry, 60 fps performance with 10k+ objects on the screen" />
<div style="display:flex; align-items:center; margin:10px;">
    <iframe
        title="Video Preview"
        style="margin:auto;"
        width="560"
        height="315"
        src="https://www.youtube.com/embed/9yPG2G8A1ok"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen />
</div>

<div style="height:40px;" />

<AppHead
    name="Social HUB (UI components kit)"
    icon="images/app_icon_sh.png"
    detail="Complex parts: 3d effects, pseudo 3d beziere path calculation, animation" />
<div style="display:flex; align-items:center; margin:10px;">
    <iframe
        title="Video Preview"
        style="margin:auto;"
        width="560"
        height="315"
        src="https://www.youtube.com/embed/5gecqtSiy-Y"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen />
</div>

<div style="height:60px;" />

{#if !hidefooter}
<AppStore />

<div style="height:90px;" />
{/if}
